var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMonitronix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre);}.cls-2{fill:url(#Degradado_sin_nombre-2);}.cls-3{fill:url(#Degradado_sin_nombre-3);}.cls-4{fill:none;clip-rule:evenodd;}.cls-13,.cls-5{fill:#bee5ee;}.cls-6{clip-path:url(#clip-path);}.cls-7{fill:url(#Degradado_sin_nombre_33);}.cls-8{clip-path:url(#clip-path-2);}.cls-9{fill:url(#Degradado_sin_nombre_34);}.cls-10{fill:#00b1c2;}.cls-10,.cls-11,.cls-13{fill-rule:evenodd;}.cls-11{fill:#45c3db;}.cls-12{mask:url(#mask);}.cls-14{mask:url(#mask-2);}.cls-15{mask:url(#mask-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre",
    x1: -89.06,
    y1: 555.84,
    x2: -95.01,
    y2: 568.15,
    gradientTransform: "translate(293.51 -427.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre-2",
    x1: -186.42,
    y1: 560.19,
    x2: -182.45,
    y2: 591.55,
    gradientTransform: "translate(274.55 -427.83)",
    xlinkHref: "#Degradado_sin_nombre"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre-3",
    x1: -143.64,
    y1: 640.04,
    x2: -143.64,
    y2: 589.6,
    gradientTransform: "translate(284.4 -427.83)",
    xlinkHref: "#Degradado_sin_nombre"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "97.77 111.53 76.09 146.04 88.18 117.46 142.47 14.8 144 24.54 97.77 111.53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_33",
    x1: 76.09,
    y1: 80.42,
    x2: 144,
    y2: 80.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bee5ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#afe0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b1c2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "188.97 123.72 212.63 159.23 199.31 128.72 180.88 94.03 178.41 101.19 188.97 123.72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_34",
    x1: 177.92,
    y1: 147.31,
    x2: 213.13,
    y2: 105.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bee5ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#afe0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b1c2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 138.11,
    y: 105.25,
    width: 104.2,
    height: 104.47,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 138.11,
    y: 105.25,
    width: 104.2,
    height: 104.47
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 39.21,
    y: 105.25,
    width: 104.2,
    height: 104.47,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.21,
    y: 105.25,
    width: 104.2,
    height: 104.47
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 90.58,
    y: 105.82,
    width: 100.35,
    height: 103.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.58,
    y: 105.82,
    width: 100.35,
    height: 103.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logitipo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.22,265.2a2.58,2.58,0,0,1-1.19-.26,2.63,2.63,0,0,1-.89-.75l.55-.55a2,2,0,0,0,.66.6,1.91,1.91,0,0,0,.91.2,1.45,1.45,0,0,0,.85-.23.75.75,0,0,0,.33-.64.91.91,0,0,0-.16-.54,1.28,1.28,0,0,0-.42-.34,3.76,3.76,0,0,0-.57-.24c-.2-.07-.41-.14-.62-.23a2.42,2.42,0,0,1-.57-.31,1.42,1.42,0,0,1-.42-.49,1.66,1.66,0,0,1-.15-.76,1.5,1.5,0,0,1,.24-.86,1.65,1.65,0,0,1,.67-.55,2.32,2.32,0,0,1,1-.2,2.38,2.38,0,0,1,1.05.23,2.07,2.07,0,0,1,.76.6l-.55.55a1.83,1.83,0,0,0-.57-.46,1.47,1.47,0,0,0-.7-.16,1.28,1.28,0,0,0-.77.21.69.69,0,0,0-.28.59.72.72,0,0,0,.16.49,1.2,1.2,0,0,0,.41.31,4.39,4.39,0,0,0,.58.24c.21.07.41.15.62.24a2.27,2.27,0,0,1,.57.32,1.51,1.51,0,0,1,.42.51,1.85,1.85,0,0,1,.16.79,1.53,1.53,0,0,1-.55,1.24A2.28,2.28,0,0,1,27.22,265.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.93,265.11v-6h.81v6Zm.55-5.23v-.74h3.39v.74Zm0,2.54v-.72h3.15v.72Zm0,2.69v-.74h3.43v.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.29,265.2a2.92,2.92,0,0,1-1.17-.24,3,3,0,0,1-1.59-1.64,3.12,3.12,0,0,1,0-2.4,3,3,0,0,1,1.61-1.64,3.18,3.18,0,0,1,1.21-.23,3.07,3.07,0,0,1,1.32.28,2.66,2.66,0,0,1,1,.79l-.56.56a1.74,1.74,0,0,0-.74-.63,2.31,2.31,0,0,0-1-.22,2.22,2.22,0,0,0-1.16.29,2,2,0,0,0-.78.81,2.67,2.67,0,0,0,0,2.38,2.07,2.07,0,0,0,.77.81,2,2,0,0,0,1.09.3,2.35,2.35,0,0,0,1.1-.24,1.7,1.7,0,0,0,.71-.72,2.59,2.59,0,0,0,.25-1.14l.49.36H43.24v-.75h2.92v.12a3.8,3.8,0,0,1-.36,1.74,2.49,2.49,0,0,1-1,1.06A3.12,3.12,0,0,1,43.29,265.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.07,265.2a2.36,2.36,0,0,1-1.19-.3,2.22,2.22,0,0,1-1.13-2v-3.76h.81v3.74a1.63,1.63,0,0,0,.2.82,1.4,1.4,0,0,0,.54.54,1.62,1.62,0,0,0,.77.18,1.55,1.55,0,0,0,.76-.18,1.45,1.45,0,0,0,.53-.54,1.62,1.62,0,0,0,.19-.81v-3.75h.82v3.77a2.26,2.26,0,0,1-.3,1.17,2.24,2.24,0,0,1-2,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.29,265.11v-6h.81v6Zm.54-2.6v-.68h1.62a1.13,1.13,0,0,0,.8-.26,1,1,0,0,0,.28-.73,1,1,0,0,0-.28-.71,1,1,0,0,0-.79-.29H58.83v-.7h1.65a2.07,2.07,0,0,1,1,.22,1.51,1.51,0,0,1,.65.6,1.66,1.66,0,0,1,.23.87,1.7,1.7,0,0,1-.23.88,1.49,1.49,0,0,1-.65.59,2.19,2.19,0,0,1-1,.21Zm2.9,2.6-2.17-2.67.77-.27,2.43,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.17,265.11v-6H67v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71,265.11v-6h.81v6Zm.53,0v-.74h1.66a2.2,2.2,0,0,0,1.16-.29,1.91,1.91,0,0,0,.78-.79,2.36,2.36,0,0,0,.29-1.17,2.32,2.32,0,0,0-.29-1.16,2,2,0,0,0-.78-.79,2.22,2.22,0,0,0-1.16-.29H71.52v-.74h1.67a3.18,3.18,0,0,1,1.21.22,2.86,2.86,0,0,1,1,.63,2.8,2.8,0,0,1,.64.95,3.17,3.17,0,0,1,0,2.37,2.92,2.92,0,0,1-.63.95,2.86,2.86,0,0,1-1,.63,3.16,3.16,0,0,1-1.2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79.48,265.11l2.46-6h.58l2.44,6h-.88l-2-5.05h.31l-2,5.05Zm1.18-1.35v-.7H83.8v.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.51,265.11v-6h.81v6Zm.53,0v-.74H90.7a2.22,2.22,0,0,0,1.16-.29,1.91,1.91,0,0,0,.78-.79,2.36,2.36,0,0,0,.28-1.17,2.32,2.32,0,0,0-.28-1.16,2,2,0,0,0-.78-.79,2.22,2.22,0,0,0-1.16-.29H89.05v-.74h1.67a3.18,3.18,0,0,1,1.21.22,2.86,2.86,0,0,1,1,.63,2.8,2.8,0,0,1,.64.95,3.17,3.17,0,0,1,0,2.37,2.92,2.92,0,0,1-.63.95,2.86,2.86,0,0,1-1,.63,3.16,3.16,0,0,1-1.2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.83,265.11v-6h.81v6Zm.55-5.23v-.74h3.38v.74Zm0,2.54v-.72h3.14v.72Zm0,2.69v-.74h3.42v.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.49,265.11v-6h.81v6Zm.55,0v-.74h3.2v.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.82,265.11v-6h.81v6Zm.56-5.23v-.74h3.38v.74Zm0,2.54v-.72h3.14v.72Zm0,2.69v-.74h3.42v.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.2,265.2A3,3,0,0,1,126,265a2.89,2.89,0,0,1-1-.66,3,3,0,0,1-.63-1,3.15,3.15,0,0,1-.22-1.19,3.21,3.21,0,0,1,.22-1.21,3.05,3.05,0,0,1,.63-1,3,3,0,0,1,2.14-.89,3,3,0,0,1,1.25.24,3.12,3.12,0,0,1,.95.66l-.56.56a2,2,0,0,0-.7-.5,2.32,2.32,0,0,0-.94-.18,2.23,2.23,0,0,0-.86.16,2.08,2.08,0,0,0-1.14,1.21,2.56,2.56,0,0,0-.16.93,2.51,2.51,0,0,0,.16.92,2.36,2.36,0,0,0,.45.73,2.2,2.2,0,0,0,.69.48,2.28,2.28,0,0,0,.87.16,2.4,2.4,0,0,0,1-.18,2,2,0,0,0,.7-.5l.56.56a3,3,0,0,1-1,.66A3.13,3.13,0,0,1,127.2,265.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.55,259.88v-.74h4.86v.74Zm2,5.23v-5.8h.82v5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141,265.11v-6h.81v6Zm.54-2.6v-.68h1.62a1.13,1.13,0,0,0,.8-.26,1,1,0,0,0,.28-.73,1,1,0,0,0-.28-.71,1,1,0,0,0-.79-.29H141.5v-.7h1.65a2.07,2.07,0,0,1,1,.22,1.51,1.51,0,0,1,.65.6,1.57,1.57,0,0,1,.23.87,1.61,1.61,0,0,1-.23.88,1.49,1.49,0,0,1-.65.59,2.19,2.19,0,0,1-1,.21Zm2.9,2.6-2.17-2.67.77-.27,2.43,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.48,265.2a3,3,0,0,1-2.15-.9,3,3,0,0,1-.65-1,3.22,3.22,0,0,1,0-2.39,3.26,3.26,0,0,1,.64-1,2.94,2.94,0,0,1,1-.66,3.06,3.06,0,0,1,1.18-.23,3.11,3.11,0,0,1,1.19.23,3.16,3.16,0,0,1,1,.66,3.08,3.08,0,0,1,.64,1,3,3,0,0,1,.23,1.21,3.09,3.09,0,0,1-.87,2.17,2.79,2.79,0,0,1-1,.66A2.85,2.85,0,0,1,151.48,265.2Zm0-.78a2.05,2.05,0,0,0,1.9-1.11,2.43,2.43,0,0,0,.28-1.19,2.47,2.47,0,0,0-.16-.92,2.08,2.08,0,0,0-1.14-1.21,2.26,2.26,0,0,0-.88-.16,2.07,2.07,0,0,0-1.89,1.1,2.52,2.52,0,0,0-.28,1.19,2.73,2.73,0,0,0,.16.92,2.15,2.15,0,0,0,.45.73,1.87,1.87,0,0,0,.69.48A2.11,2.11,0,0,0,151.46,264.42Zm-.51-5.89-.35-.36,1.12-1.38.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.18,265.11v-6h.57l.24.95v5Zm4.13,0-3.67-4.89.11-1.08,3.67,4.89Zm0,0-.24-.88v-5.09h.81v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M166.87,265.11v-6h.81v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.39,265.2a3,3,0,0,1-1.2-.24,2.89,2.89,0,0,1-1-.66,3,3,0,0,1-.63-1,3.15,3.15,0,0,1-.22-1.19,3.21,3.21,0,0,1,.22-1.21,3.05,3.05,0,0,1,.63-1,3,3,0,0,1,2.14-.89,3,3,0,0,1,1.25.24,3.12,3.12,0,0,1,.95.66l-.56.56a2,2,0,0,0-.7-.5,2.32,2.32,0,0,0-.94-.18,2.2,2.2,0,0,0-.86.16,2.08,2.08,0,0,0-1.14,1.21,2.56,2.56,0,0,0-.16.93,2.51,2.51,0,0,0,.16.92,2.36,2.36,0,0,0,.45.73,2,2,0,0,0,1.56.64,2.4,2.4,0,0,0,1-.18,2,2,0,0,0,.7-.5l.56.56a3,3,0,0,1-1,.66A3.13,3.13,0,0,1,174.39,265.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.74,265.11l2.45-6h.59l2.43,6h-.88l-2-5.05h.31l-2,5.05Zm1.17-1.35v-.7h3.14v.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.19,265.11l2.46-6h.58l2.44,6h-.88l-2-5.05h.31l-2,5.05Zm1.18-1.35v-.7h3.14v.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.35,265.11l-2.4-6h.89l2,5.05h-.32l2-5.05h.87l-2.41,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207.64,265.11l2.45-6h.59l2.44,6h-.88l-2-5.05h.31l-2,5.05Zm1.17-1.35v-.7H212v.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.66,265.11v-6h.57l.24.95v5Zm4.14,0-3.67-4.89.1-1.08,3.68,4.89Zm0,0-.24-.88v-5.09h.8v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M225,264.55l3.38-4.85h.95l-3.37,4.85Zm0,.56v-.56l.7-.18h3.57v.74Zm.18-5.23v-.74h4.15v.56l-.7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232.27,265.11l2.46-6h.58l2.44,6h-.88l-2-5.05h.31l-2,5.05Zm1.17-1.35v-.7h3.15v.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M241.3,265.11v-6h.81v6Zm.53,0v-.74h1.66a2.22,2.22,0,0,0,1.16-.29,1.91,1.91,0,0,0,.78-.79,2.36,2.36,0,0,0,.28-1.17,2.32,2.32,0,0,0-.28-1.16,2,2,0,0,0-.78-.79,2.22,2.22,0,0,0-1.16-.29h-1.65v-.74h1.67a3.21,3.21,0,0,1,1.21.22,2.86,2.86,0,0,1,1,.63,2.8,2.8,0,0,1,.64.95,3.17,3.17,0,0,1,0,2.37,2.92,2.92,0,0,1-.63.95,2.86,2.86,0,0,1-1,.63,3.16,3.16,0,0,1-1.2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249.8,265.11l2.46-6h.58l2.44,6h-.88l-2-5.05h.31l-2,5.05Zm1.17-1.35v-.7h3.15v.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 76.09,
    y: 14.8,
    width: 67.91,
    height: 131.24
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 178.41,
    y: 94.03,
    width: 34.21,
    height: 65.2
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "98.87 113.41 47.98 209.71 39.21 209.71 94.66 105.25 98.87 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "90.58 113.22 139.82 209.71 141.72 209.71 143.41 199.89 94.97 105.82 90.58 113.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "182.65 113.41 233.54 209.71 242.31 209.71 186.86 105.25 182.65 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "190.93 113.22 141.69 209.71 139.8 209.71 138.11 199.89 186.55 105.82 190.93 113.22"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "186.82 121.29 233.54 209.71 242.31 209.71 186.86 105.25 186.56 105.83 186.55 105.82 138.11 199.89 139.8 209.71 141.7 209.71 186.82 121.29"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "94.7 121.29 47.98 209.71 39.21 209.71 94.66 105.25 94.96 105.83 94.97 105.82 143.41 199.89 141.72 209.71 139.82 209.71 94.7 121.29"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "90.58 113.22 139.79 209.65 139.8 209.71 139.82 209.71 141.7 209.71 141.72 209.71 141.73 209.65 190.94 113.22 186.55 105.82 140.76 194.74 94.97 105.82 90.58 113.22"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.42,248.38l8.11-13.28L234,223.39h3.76l5.66,9.51,5.46-9.51h3.56l-7.48,12,8.41,13h-3.68l-6.51-10.77L237,248.38Zm-6.12,0v-25h3.13v25Zm-28.62,0v-26l19.29,20v-19h3v26l-19.29-19.74v18.77Zm-5.14-12.44a12.31,12.31,0,0,1-1,5.05,12.55,12.55,0,0,1-3,4.21,14.36,14.36,0,0,1-4.61,2.84,15,15,0,0,1-10.78,0,14.33,14.33,0,0,1-4.58-2.84,12.68,12.68,0,0,1-3.07-4.23,12.54,12.54,0,0,1,0-10.09,12.62,12.62,0,0,1,3.07-4.24,14.07,14.07,0,0,1,4.58-2.82,15.22,15.22,0,0,1,10.8,0,14,14,0,0,1,4.59,2.82,12.59,12.59,0,0,1,3,4.22A12.45,12.45,0,0,1,193.54,235.94Zm-14.08,10.3a11,11,0,0,0,4.11-.77,11.12,11.12,0,0,0,3.52-2.27,10.05,10.05,0,0,0,2.36-3.32,9.78,9.78,0,0,0,.81-3.94,10.11,10.11,0,0,0-.81-4,10.22,10.22,0,0,0-2.36-3.34,10.73,10.73,0,0,0-3.5-2.24,11.26,11.26,0,0,0-4.13-.77,11.4,11.4,0,0,0-4.17.77,10.3,10.3,0,0,0-3.47,2.24,10.16,10.16,0,0,0-2.36,3.36,9.94,9.94,0,0,0-.81,4,9.81,9.81,0,0,0,.79,3.92,10.31,10.31,0,0,0,2.38,3.34,10.75,10.75,0,0,0,7.64,3ZM149.9,225.91v8.35h2.39c2.46,0,4.1-.3,4.93-.9a3.57,3.57,0,0,0,1.24-3.12,4,4,0,0,0-1.28-3.37q-1.27-1-4.89-1Zm-3.06,22.47v-25H153a19,19,0,0,1,3.88.28,5.53,5.53,0,0,1,4,3.3,7.9,7.9,0,0,1,.65,3.23,5.86,5.86,0,0,1-1.81,4.66,7.76,7.76,0,0,1-5.3,1.6h-.57L164,248.38h-4l-9.63-11.92h-.44v11.92Zm-14.09,0V226.22H125.3v-2.83h18v2.83h-7.41v22.16Zm-14.12,0v-25h3.14v25Zm-28.62,0v-26l19.3,20v-19h3v26L93,229.61v18.77Zm-5.13-12.44a12.4,12.4,0,0,1-4.09,9.26,14.32,14.32,0,0,1-4.6,2.84,14.9,14.9,0,0,1-5.4,1,14.71,14.71,0,0,1-5.38-1,14.49,14.49,0,0,1-4.59-2.84A13,13,0,0,1,57.75,241a12.64,12.64,0,0,1,0-10.09,12.9,12.9,0,0,1,3.07-4.24,14.07,14.07,0,0,1,4.58-2.82,15.19,15.19,0,0,1,5.39-1,15.39,15.39,0,0,1,5.42,1,14.07,14.07,0,0,1,4.58,2.82,12.45,12.45,0,0,1,4.09,9.3Zm-14.09,10.3a10.87,10.87,0,0,0,7.63-3,9.91,9.91,0,0,0,2.36-3.32,9.63,9.63,0,0,0,.82-3.94,9.94,9.94,0,0,0-.82-4,10.07,10.07,0,0,0-2.36-3.34,10.73,10.73,0,0,0-3.5-2.24,11.22,11.22,0,0,0-4.13-.77,11.47,11.47,0,0,0-4.17.77,10.76,10.76,0,0,0-5.83,5.6,9.94,9.94,0,0,0-.81,4,9.65,9.65,0,0,0,.8,3.92,10.28,10.28,0,0,0,2.37,3.34,10.75,10.75,0,0,0,7.64,3Zm-31.5,3.11L31.1,231.4l-3.32,17H24.72l5.35-26,9.22,20.65,9.22-20.65,5.35,26H50.8l-3.35-17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMonitronix);
export default __webpack_public_path__ + "static/media/logo-monitronix.2aca6cb5bc121fb3c8c8387d79ae386a.svg";
export { ForwardRef as ReactComponent };